var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 54,
    viewBox: "0 0 63 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\x93\xB1\xEC\x82\xB0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6287 25.3976C19.995 25.3976 22.7239 22.6761 22.7239 19.3188C22.7239 15.9616 19.995 13.24 16.6287 13.24C13.2624 13.24 10.5335 15.9616 10.5335 19.3188C10.5335 22.6761 13.2624 25.3976 16.6287 25.3976Z",
    fill: "#FC8368"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.7127 14.4279C25.3574 11.597 29.4704 11.597 31.1151 14.4279L37.8829 26.0788L44.6507 37.7297C46.2954 40.5606 44.2389 44.1016 40.9495 44.1016H13.8759C10.5865 44.1016 8.52998 40.5606 10.1747 37.7297L16.9425 26.0788L23.7127 14.4279Z",
    fill: "#067DFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.4951 20.5374C40.7936 18.2893 44.0407 18.2893 45.3391 20.5374L50.6821 29.7896L56.0251 39.0418C57.3236 41.2898 55.7 44.1018 53.1031 44.1018H31.7292C29.1323 44.1018 27.5088 41.2898 28.8072 39.0418L34.1502 29.7896L39.4951 20.5374Z",
    fill: "#067DFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 46",
    d: "M36.9977 24.7056L27.8949 43.756",
    stroke: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/등산.ba3d0ad5a21586b131c45d6ecddbf891.svg";
export { ForwardRef as ReactComponent };